import React from 'react';
import Credentialing from './Credentialing/Index';

function Index() {
  return <Credentialing />;
}

export default Index;
